import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';

import LeaderSearch from '../../leader-components/leader-search';
import { useDispatch, useSelector } from 'react-redux';
import LeaderIcon from '../leader-icon';
import { setFollowFilter, setLeadersList, setLeaderSearchTerm } from '../../../store/';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0),
    },
    leaderWrapper: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    leaderName: {
      fontSize: '.75em',
      fontWeight: 'bold',
      textAlign: 'center',
    },
  }),
);

export default function LeaderFollowed(props: any) {
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();
  const following = useSelector((state: any) => state.leaders.follow);
  // const [selected, setSelected] = useState('all');
  const selected = useSelector((state: any) => state.leaders.followFilter);

  const handleLeaderClick = (id: string) => () => {
    dispatch(setLeadersList({ leaders: [], lastItem: null }));
    dispatch(setLeaderSearchTerm(''));
    dispatch(setFollowFilter(id));
  };

  const isSelected = (id: string) => selected === id;

  const renderLeader = (leader: any) => (
    <Grid
        className={classes.leaderWrapper}
        direction="column"
        item
        onClick={handleLeaderClick(leader.id)}>
      <LeaderIcon
        isSelected={isSelected(leader.id)}
        displayName={leader.displayName}
        avatarImg={leader.photoUrl || 'broken.jpg'}
        size="small"
      />
      <div className={classes.leaderName}>
        {leader.displayName}
      </div>
    </Grid>
  );

  return (
    <Grid item container className={classes.root} xs={12}>
      <Grid xs={9} container>
        <Grid className={classes.leaderWrapper} item direction="column" onClick={handleLeaderClick('all')}>
          <LeaderIcon
            isSelected={isSelected('all')}
            displayName="All"
            avatarImg=""
            size="small"
          />
          <div className={classes.leaderName}>
            All
          </div>
        </Grid>
        {following.map((follow: any) => renderLeader(follow.leader))}
      </Grid>
      <Grid xs={3}>
        <LeaderSearch />
      </Grid>
    </Grid>
  );
}
